module.exports = __webpack_public_path__ + "img/qiye.b20e66b9.svg";